import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M12 8a4 4 0 10-4 4v16h16V12a4 4 0 10-4-4 4 4 0 10-8 0zm1 8v12m6-12v12"
      fill="none"
    />
  </Icon>
);
